import msg from '../getErrorMsg';
import defaults from 'DEFAULTS';

export default (input, params, context) => {
  if (!defaults.re.currency.test(input.value)) {
    return msg(context, 'notCurrency');
  }

  return false;
};
